import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { PageWithLayout } from '@/pages/_app';
import { Helmet } from 'react-helmet-async';
import { VouchersContent } from '@starjack/widgets/vouchers';
import { Permission } from '@/models/user';

const Vouchers: PageWithLayout = () => {
    return (
        <>
            <Helmet>
                <title>Gutscheine | Starjack Backoffice</title>
            </Helmet>

            <VouchersContent />
        </>
    );
};

Vouchers.getLayout = (page) => <SidebarLayout>{page}</SidebarLayout>;
Vouchers.isProtected = true;
Vouchers.permissions = [Permission.SUPPORTER];

export default Vouchers;
